(function() {
  'use strict';

  /**
   * @ngdoc factory
   * @name smsManager.factory:SmsManagerFactory
   *
   * @description
   *
   */
  angular.module('smsManager').factory('SmsManagerFactory', SmsManagerFactory);

  function SmsManagerFactory() {

    // ----declare DTOs------
    function SmsManagerSearchRequest() {
      this.fromDate = null;
      this.toDate = null;
      this.refreshStatus = false;
      this.crewBase = null;
      this.status = null;
      this.crewProfileId = null;
      this.startPosition = 1;
      this.pageSize = 60;
    }

    function MessageDetailDTO() {
      this.smsId = null;
      this.messageId = null;
      this.createdDate = null;
      this.userName = null;
      this.crewName = null;
      this.message = null;
      this.status = null;
      this.statusName = null;
      this.crewProfileId = null;
      this.confirmationId = null;
      this.confirmedDate = null;
      this.confirmationDuration = null;
      this.messageType = null;
    }

    // ----Define Function --------
    function GetSmsManagerSearchRequest() {
      return new SmsManagerSearchRequest();
    }

    function GetFormattedSmsManagerSearchRequest(searchCriteria) {
      var searchReq = new SmsManagerSearchRequest();
      searchReq.fromDate = searchCriteria.fromDate;
      searchReq.toDate = searchCriteria.toDate;
      searchReq.refreshStatus = searchCriteria.refreshStatus;
      
      if (searchCriteria.crewProfileId) {
          searchReq.crewProfileId = searchCriteria.crewProfileId;
      }
      
      if (searchCriteria.crewBase) {
        searchReq.crewBase = searchCriteria.crewBase;
      }
      if (searchCriteria.status) {
        searchReq.status = searchCriteria.status;
      }
      if(searchCriteria.startPosition){
        searchReq.startPosition = searchCriteria.startPosition;
      }
      if(searchCriteria.pageSize){
        searchReq.pageSize = searchCriteria.pageSize;
      }
      return searchReq;
    }

    function GetFormattedMessageList(messages){
      var messageList = [];
      if(!!messages && messages.length > 0){
        for (var i = 0; i < messages.length; i++) {
          var msg = messages[i];
          var formattedMsg = new MessageDetailDTO();
          formattedMsg.smsId = msg.smsID;
          formattedMsg.messageId = msg.messageID;
          formattedMsg.createdDate = msg.createdDate;
          formattedMsg.userName = msg.userNa;
          formattedMsg.crewName = msg.crewName;
          formattedMsg.message = msg.mesage;
          formattedMsg.status = msg.status;
          formattedMsg.statusName = msg.statusName;
          formattedMsg.crewProfileId = msg.crewProfileID;
          formattedMsg.confirmationId = msg.confirmationID;
          formattedMsg.confirmedDate = msg.confirmedDate;
          formattedMsg.confirmationDuration = msg.confirmationDuration;
          formattedMsg.messageType = msg.mesageType;

          messageList.push(formattedMsg);
        }
      }
      return messageList;
    }

    // map services to return
    return {
      getSmsManagerSearchRequest : GetSmsManagerSearchRequest,
      getFormattedSmsManagerSearchRequest : GetFormattedSmsManagerSearchRequest,
      getFormattedMessageList : GetFormattedMessageList
    }

  }
})();
